import dateFormat from 'dateformat';
export let apiServer;
export let apiDomainLocation = 'plaync.com';

const hostName = location.hostname;

if (!hostName.indexOf('local.')) {
  apiServer = '//local.';
}else if (!hostName.indexOf('opdev.')) {
  apiServer = '//opdev.';
} else if (!hostName.indexOf('sb-')) {
  apiServer = '//sb-';
} else if (!hostName.indexOf('rc-')) {
  apiServer = '//rc-';
} else {
  apiServer = '//';
}

if (~hostName.indexOf('ncsoft.jp')) {
  apiDomainLocation = 'ncsoft.jp';
}

const domain = window.guidebook.domain; // Todo: 레거시 (제거 예)
const apiDomain = window.guidebook.apiDomain;

export let apiUrl;

if (apiDomain) {
  apiUrl = `${apiDomain}/api/v2`;
} else {
  // apiUrl = `${apiServer}${location.origin}/api/v1`; // Todo: 이 한줄로 변경
  if (domain) { // Todo: 레거시 (제거 예정)
    apiUrl = `${apiServer}${domain}/api/v2`;
  } else {
    apiUrl = `${apiServer}${location.host}/api/v2`;
  }
}

// 언어
export const language = $('html').attr('lang') || 'ko';

// 서비스 코드
export const serviceCode = window.guidebook.service;

// 자동완성 서비스 코드
export const suggestServiceCode = window.guidebook.suggest;

//운영툴 타입
export const adminType = window.guidebook.adminType ? window.guidebook.adminType : 'contents';

// 컨텐츠 어드민 도메인
export const contentsAdminDomin = window.guidebook.contentsAdminDomin;

// 컨텐츠 어드민 URI
export const contentsAdminUri = window.guidebook.contentsAdminUri;


// conti 어드민 인기 가이드
export const contiGbPopApi = window.guidebook.contiGbPopApi;

// conti 어드민 기본 가이드
export const contiGbBasicURL = window.guidebook.contiGbBasicURL;

// 인터넷익스플로어 체크
export const isIE = (navigator.appName === 'Netscape' && navigator.userAgent.search('Trident') !== -1);

// 쿠키사용 여부
export const useCookie = function(){
  let used = null;
  if(language == 'ko'){
    used = true;
  }else{
    used = JSON.parse(decodeURIComponent(getCookie('applyCookie')));
    used = used?.typeArr?.indexOf('FUNCTIONAL');
    used = (used !== undefined) && (used > -1);

  }
  return used;
}();

// 쿠키 저장하기
export function setCookie (name, value) {
  const date = new Date();

  date.setTime(date.getTime() + (7 * 24 * 60 * 60 * 1000));
  document.cookie = `${name}=${encodeURI(value)};expires=${date.toUTCString()};path=/`;
}

// 쿠키 가져오기
export function getCookie (name) {
  const nameEQ = `${name}=`;
  const cookieArray = document.cookie.split('; ');

  for (let i = 0; i < cookieArray.length; i++) {
    let c = cookieArray[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURI(c.substring(nameEQ.length, c.length));
  }

  return null;
}

// 쿠키 삭제하기
export function deleteCookie (name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
}

// 해시 오브젝트로 변환
export function getHash () {
  let hash = {};

  location.hash.substr(1).split('&').forEach(function (item) {
    hash[item.split('=')[0]] = item.split('=')[1];
  });

  return hash;
}

// 파라미터 오브젝트로 변환
export function getParameter () {
  let parameter = {};

  location.search.substr(1).split('&').forEach(function (item) {
    parameter[item.split('=')[0]] = item.split('=')[1];
  });

  return parameter;
}

export function getFormatDate(date){
  return dateFormat(new Date(date), 'yyyy-mm-dd');
  // if(serviceCode == 'lineagew' || serviceCode == 'l2mru' || serviceCode == 'l2mnu'){
  //   return dateFormat(new Date(date), 'yyyy-mm-dd');
  // }else{
  //   return dateFormat(new Date(date), 'yyyy. mm. dd');
  // }
}
// HTML 태그 제거
export function removeTags (html) {
  return html.replace(/(<([^>]+)>)/ig, '');
}

// userData 로케일 가져오기
export function getLocale(){
  if(!window.userData.locale){
    return 'kr';
  }
  const [lang, country] = window.userData.locale.toLowerCase().split('-');
  return {
    lang,
    country,
  };
}
